import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Client } from '@df/core/service/client';
import { NDfs } from '../dfs.interfaces';
import { DfsPerSizeNormalizeService } from '../util/dfs-per-size-normalize';
import { DfsCssService } from './dfs-css.service';
import { DfsGlobalsService } from './dfs-globals.service';

@Injectable({
    providedIn: 'root'
})
export class DfsGlobalsServiceFactory {
    private assets: { [key: string]: DfsGlobalsService } = {};

    get(dfsOptions: NDfs.IOptions) {
        if (!this.assets[dfsOptions.scope]) {
            this.assets[dfsOptions.scope] = new DfsGlobalsService(
                dfsOptions,
                this.client,
                this.dfsCssService,
                this.dfsPerSizeNormalizeService,
                this.document
            );
        }
        return this.assets[dfsOptions.scope];
    }

    /**
     * Dependencies
     */
    constructor(
        private client: Client,
        private dfsCssService: DfsCssService,
        private dfsPerSizeNormalizeService: DfsPerSizeNormalizeService,
        @Inject(DOCUMENT) private document: Document
    ) {}
}
